import axiosInstance from "../interceptor/intercetptor-inctence";

/** POST /pharma/masterCountries — { search } */
export const getMasterCountries = (data = {}) =>
	axiosInstance.post(`/pharma/masterCountries`, data);

/** POST /pharma/masterStates — { country } (use selected country code/name from countries API) */
export const getMasterStates = (data = {}) =>
	axiosInstance.post(`/pharma/masterStates`, data);

/** Normalize country API row → react-select option */
export const mapCountryToOption = (item = {}) => {
	const label =
		item.name ||
		item.country ||
		item.Country ||
		item.label ||
		item.countryName ||
		"";
	if (!label) return null;

	const code =
		item.code ||
		item.iso3 ||
		item.isoCode ||
		item.iso2 ||
		item.country_code ||
		item.countryCode ||
		"";

	return {
		label: String(label),
		value: String(label),
		/** Identifier for masterStates — whatever the countries API provides */
		code: code ? String(code) : String(label),
		raw: item,
	};
};

export const mapCountriesToOptions = (list = []) =>
	(Array.isArray(list) ? list : []).map(mapCountryToOption).filter(Boolean);

/**
 * Value sent as masterStates.country.
 * Uses the selected option's API code when present, otherwise its name.
 */
export const getCountryQueryKey = (optionOrName) => {
	if (!optionOrName) return "";
	if (typeof optionOrName === "string") return optionOrName.trim();
	return String(
		optionOrName.code || optionOrName.value || optionOrName.label || ""
	).trim();
};

/** GST State Code field is India-specific */
export const isIndiaCountry = (optionOrName) => {
	const text = String(
		typeof optionOrName === "object"
			? optionOrName?.label ||
					optionOrName?.value ||
					optionOrName?.code ||
					""
			: optionOrName || ""
	)
		.toLowerCase()
		.trim();
	return text === "india" || text === "ind" || text === "in";
};

export const loadCountryOptions = async (inputValue) => {
	const search = String(inputValue || "").trim();
	if (search.length < 2) return [];

	try {
		const response = await getMasterCountries({ search });
		const list =
			response?.data?.data?.countries ||
			response?.data?.data ||
			response?.data ||
			[];
		return mapCountriesToOptions(Array.isArray(list) ? list : []);
	} catch (error) {
		console.error("Error loading countries:", error);
		return [];
	}
};

export const mapStateToOption = (item = {}) => {
	const label = item.State || item.state || item.name || item.label || "";
	if (!label) return null;
	return {
		label: String(label),
		value: String(label),
		gstCode: item.gstCode || item.stateCode || item.code || "",
		raw: item,
	};
};

export const loadStateOptions = async (countryOptionOrKey) => {
	const country = getCountryQueryKey(countryOptionOrKey);
	if (!country) return [];

	try {
		const response = await getMasterStates({ country });
		const list = response?.data?.data || response?.data || [];
		return (Array.isArray(list) ? list : [])
			.map(mapStateToOption)
			.filter(Boolean);
	} catch (error) {
		console.error("Error loading states:", error);
		throw error;
	}
};

export const toCountrySelectValue = (country) => {
	if (!country) return null;
	if (typeof country === "object") return country;
	const text = String(country).trim();
	return text ? { label: text, value: text, code: text } : null;
};

export const toStateSelectValue = (state, stateCode = "") => {
	if (!state) return null;
	if (typeof state === "object") return state;
	const text = String(state).trim();
	return text
		? { label: text, value: text, gstCode: stateCode || "" }
		: null;
};
